<template>
  <div>
    <van-nav-bar
      :title="generateCustomizeString('orderSearch')"
      :left-text="generateCustomizeString('goBack')"
      left-arrow
      @click-left="onClickLeft"
      @click-right="scanAction"
    >
      <img slot="right" :src="scan" style="width: 18px; vertical-align: middle;" />
    </van-nav-bar>
    <van-search
      v-model="searchKey"
      :placeholder="generateCustomizeString('searchPlaceHolder')"
      show-action
      @search="onSearch"
    >
      <div slot="action" @click="onSearch">{{generateCustomizeString('search')}}</div>
    </van-search>
    <order-list :isSearch="true" ref="orderList"></order-list>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import {
  Field,
  Cell,
  CellGroup,
  Row,
  Col,
  Button,
  Search,
  NavBar,
  Icon,
  Toast
} from 'vant'
import OrderList from '@/views/orders/components/OrderList'
import wxConfig from '@/utils/wxConfig'
import scan from '@/assets/scan.png'

export default {
  name: 'search',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Search.name]: Search,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    OrderList
  },
  data() {
    return {
      searchKey: '',
      scan: scan
    }
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.go(-1)
    },
    scanAction() {
      const that = this
      wxConfig.scanQRCode().then(key => {
        that.searchKey = key
        that.$refs.orderList.fetchDataUseKeyword(that.searchKey)
      })

      // wxConfig.scanCode(function(res) {
      //   const result = res.resultStr
      //   const resultArr = result.split(',')
      //   const key = resultArr[1]
      //   that.searchKey = key
      //   that.$refs.orderList.fetchDataUseKeyword(that.searchKey)
      // })
    },
    onSearch() {
      this.$refs.orderList.fetchDataUseKeyword(this.searchKey)
    }
  },
  mounted: function() {
    if (this.$route.params.fromHome === 1) {
      this.searchKey = this.$route.params.key
      this.$refs.orderList.fetchDataUseKeyword(this.searchKey)
    }
  },
  created: function() {
    // wxConfig.config()
    if (this.$route.params.fromHome === 1) {
      this.searchKey = this.$route.params.key
      this.$refs.orderList.fetchDataUseKeyword(this.searchKey)
    } else {
      this.searchKey = ''
    }
  }
}
</script>

<style scoped>
</style>
<style type="text/css">
.van-field__control {
  line-height: 24px !important;
}
</style>
